import { useLoader } from 'src/provider/LoaderProvider';
import { useParams } from 'react-router-dom';
import {
  useGetFreshdeskEmailAgentsQuery,
  useGetFreshdeskEmailGroupsQuery,
  useGetProjectByIdQuery,
} from 'src/services';
import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAppSelector } from 'src/store';
import { ProductsTypeBack } from 'src/constants/products';
import { InputInfoToolTip } from 'src/components/Input/InputInfoToolTip';
import { AgentsSelect } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/AgentsSelect/AgentsSelect';
import { EscalationGroupSelect } from 'src/components/Integrations/IntegrationForms/IntegrationFormFields/EscalationGroupSelect/EscalationGroupSelect';

const InitialAgents = [];
const InitialGroups = [];

export const EditFreshdeskEmailAutoSetupSettings = ({ integration }) => {
  const { id } = useParams();
  const loader = useLoader();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id }) as any;
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [agents, setAgents] = useState(InitialAgents);
  const [groups, setGroups] = useState(InitialGroups);
  const {
    data: agentsResponse,
    isSuccess: isSuccessAgents,
    isLoading: isLoadingAgents,
    isError: isErrorAgents,
  } = useGetFreshdeskEmailAgentsQuery(
    {
      projectId: id,
      integrationId: selectedIntegration?.id,
      type: ProductsTypeBack[currentProject?.project_type],
    },
    { skip: !selectedIntegration || !selectedIntegration.id || !currentProject },
  );

  const {
    data: groupsResponse,
    isSuccess: isSuccessGroups,
    isLoading: isLoadingGroups,
    isError: isErrorGroups,
  } = useGetFreshdeskEmailGroupsQuery(
    {
      projectId: id,
      integrationId: selectedIntegration?.id,
      type: ProductsTypeBack[currentProject?.project_type],
    },
    { skip: !selectedIntegration || !selectedIntegration.id || !currentProject },
  );

  useEffect(() => {
    if (agentsResponse) {
      setAgents([...InitialAgents, ...(agentsResponse as any[])]);
    }
    if (groupsResponse) {
      setGroups([...InitialGroups, ...(groupsResponse as any[])]);
    }
  }, [agentsResponse, groupsResponse]);

  useEffect(() => {
    if (isSuccessGroups) {
    }
  }, [isSuccessGroups]);

  useEffect(() => {
    if (isLoadingAgents || isLoadingGroups) {
      loader.show();
    } else {
      loader.hide();
    }
  }, [isLoadingAgents, isLoadingGroups]);

  const { control, setValue } = useFormContext();

  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      {!isErrorAgents && !isErrorGroups ? (
        <div className={'flex flex-col gap-2.5'}>
          {agents.length > 0 && (
            <AgentsSelect
              label={
                <div className={'flex flex-row gap-2 items-center mb-1'}>
                  Freshdesk account for AI{' '}
                  <InputInfoToolTip
                    infoToolTip={{
                      side: 'right',
                      description: <>AI will use this account to handle tickets.</>,
                    }}
                  />
                </div>
              }
              name={'responder_id'}
              options={agents}
              control={control}
              setValue={setValue}
            />
          )}
          {groups.length > 0 && (
            <EscalationGroupSelect
              label={
                <div className={'flex flex-row gap-2 items-center mb-1'}>
                  Escalation group{' '}
                  <InputInfoToolTip
                    infoToolTip={{
                      side: 'right',
                      description: <>AI will assign escalated tickets to this group.</>,
                    }}
                  />
                </div>
              }
              control={control}
              name={'escalate_assign_group_id'}
              options={groups}
            />
          )}
        </div>
      ) : (
        <p>
          The Freshdesk details you entered seem invalid. Please double-check your subdomain, and
          API token following{' '}
          <a href={selectedIntegration.setupGuideUrl} target="_blank" rel="noreferrer">
            this guide
          </a>
          .
        </p>
      )}
    </div>
  );
};
